export default "__VITE_ASSET__1zpTEDg$__"